import React, {useState, useCallback} from 'react';
import {useDropzone} from "react-dropzone";
import {uploadShippingStatusUpdate} from "../services/ReplenishmentModule";
import {toast} from "react-toastify";
import {Button} from "reactstrap";

export const ShippingStatusSyncer = () => {

    const [selectedFiles, setSelectedFiles] = useState([]);

    const onDrop = useCallback(acceptedFiles => {
        setSelectedFiles([...acceptedFiles])
    });

    const removeAll = () => {
        setSelectedFiles([]);
    };

    const {acceptedFiles, getRootProps, getInputProps} = useDropzone({
        multiple: false,
        onDrop
    });

    const files = selectedFiles.map(file => (
        <li key={file.path}>
            {file.path} - {file.size} bytes
        </li>
    ));

    const doUpload = () => {
        if (selectedFiles.length === 0) return;
        if (selectedFiles.length > 1) return;

        uploadShippingStatusUpdate(selectedFiles[0]).then((response) => {
            if (response.status === 200) {
                toast.success('Status wurde aktualisiert');
                removeAll();
            } else {
                toast.error('Status konnte nicht aktualisiert werden!');
            }
        }).catch((error) => {
            console.log(error);
            toast.error('Status konnte nicht aktualisiert werden!');
        });
    };

    const uploadDisabled = selectedFiles.length !== 1;

    return (
        <div className="row">
            <div className="col-lg-12">
                <h4 className="card-title">Abgleich Auftragsstatus</h4>
                <div className="row">
                    <div className="col-lg-12">
                        <section className="dropzone-container">
                            <div {...getRootProps({className: 'dropzone'})}>
                                <input {...getInputProps()} />
                                <p>Drag 'n' drop oder klicken, um Datei zu wählen</p>
                            </div>
                            <aside>
                                <h6>Gewählte Datei:</h6>
                                <ul>{files}</ul>
                            </aside>
                        </section>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-12">
                        <Button disabled={uploadDisabled} color="primary" onClick={doUpload}>Status
                            aktualisieren</Button>{' '}
                        <Button color="secondary" onClick={removeAll}>Abbrechen</Button>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default ShippingStatusSyncer;


// WEBPACK FOOTER //
// ./src/admin/sync/ShippingStatusSyncer.js